import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaPt020 {
  // GET parameters
  export namespace Get {
    export interface Request {
      query: {
        grade: number
      }
    }

    // API Response
    interface PassingSpotsObject {
      puchipoSpotId: string
      puchipoSpotImageUrl: string
      puchipoSpotTextDisp: string
      nextNeededPoint: number
    }

    export interface Response {
      memNum: string
      grade: number
      puchipo: number
      reachSpot: string
      nextNeededPoint: number
      passingSpots: PassingSpotsObject[]
    }
  }

  // API Path
  const path: string = '/ta/puchipo'

  // API本体
  export class Api
    extends ApiBase
    implements Gettable<Get.Request, Get.Response, ResponseError>
  {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      const validationSample: Get.Response = {
        memNum: '',
        grade: 0,
        puchipo: 0,
        reachSpot: '',
        nextNeededPoint: 0,
        passingSpots: [
          {
            puchipoSpotId: '',
            puchipoSpotImageUrl: '',
            puchipoSpotTextDisp: '',
            nextNeededPoint: 0,
          },
        ],
      }

      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
